// Generated by scripts/update-seeq-icons.js from src/svg/seeq/dash.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcDash = {
  prefix: 'fak',
  iconName: 'dash' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f906',
    'M0 465.9h317.4v46.1h-317.4v-46.1zM629.8 512h358.4v46.1h-358.4v-46.1zM629.8 465.9h358.4v46.1h-358.4v-46.1zM0 512h317.4v46.1h-317.4v-46.1z',
  ],
} satisfies IconDefinition;
